<template>
  <div class="Index">
    <div class="window_bg"></div>
    <div class="haerd">
      <div class="haerd_left">
        <div class="backBtn" @click.stop.prevent="goBack">返 回</div>
        <div class="title">医疗健康</div>
      </div>
      <div class="haerd_right"></div>
    </div>

    <div class="module_box">
      <div class="health" @click.stop.prevent="goRegister">
        <div class="module_left">预约挂号</div>

        <div class="module_right_icon1 Register1">
          <div class="module_right_icon2 Register2">
            <div class="module_right_icon3 Register3"></div>
          </div>
        </div>
      </div>
      <div class="health" @click.stop.prevent="goPay">
        <div class="module_left">医保支付</div>

        <div class="module_right_icon1 Pay1">
          <div class="module_right_icon2 Pay2">
            <div class="module_right_icon3 Pay3"></div>
          </div>
        </div>
      </div>
      <div class="health" @click.stop.prevent="goMedicine">
        <div class="module_left">手机买药</div>

        <div class="module_right_icon1 Medicine1">
          <div class="module_right_icon2 Medicine2">
            <div class="module_right_icon3 Medicine3"></div>
          </div>
        </div>
      </div>
      <div class="health" @click.stop.prevent="goConsultation">
        <div class="module_left">在线问诊</div>

        <div class="module_right_icon1 Consultation1">
          <div class="module_right_icon2 Consultation2">
            <div class="module_right_icon3 Consultation3"></div>
          </div>
        </div>
      </div>
      <div class="health" @click.stop.prevent="goQuery">
        <div class="module_left">医保账户查询</div>

        <div class="module_right_icon1 Query1">
          <div class="module_right_icon2 Query2">
            <div class="module_right_icon3 Query3"></div>
          </div>
        </div>
      </div>
      <div class="health" @click.stop.prevent="goActivation">
        <div class="module_left">医保电子凭证激活</div>

        <div class="module_right_icon1 Activation1">
          <div class="module_right_icon2 Activation2">
            <div class="module_right_icon3 Activation3"></div>
          </div>
        </div>
      </div>
      <div class="health" @click.stop.prevent="goInsurance">
        <div class="module_left w180">城乡居民医疗保险缴费</div>

        <div class="module_right_icon1 Insurance1">
          <div class="module_right_icon2 Insurance2">
            <div class="module_right_icon3 Insurance3"></div>
          </div>
        </div>
      </div>
      <div class="health" @click.stop.prevent="goApply">
        <div class="module_left w180"  >门诊慢特病病种申请</div>

        <div class="module_right_icon1 Apply1">
          <div class="module_right_icon2 Apply2">
            <div class="module_right_icon3 Apply3"></div>
          </div>
        </div>
      </div>
    </div>
    <div class="prompt">温馨提示：模拟体验，非真实操作。</div>
  </div>
</template>
<script>
export default {
  name: "index",
  data() {
    return {};
  },
  created() {},

  mounted() {},
  beforeDestroy() {},

  methods: {
    async goRegister() {
      this.$router.push({
        path: "/health/register/index",
      });
    },
    async goPay() {
      this.$router.push({
        path: "/health/pay/index",
      });
    },
    async goMedicine() {
      this.$router.push({
        path: "/health/medicine/index",
      });
    },
    async goConsultation() {
      this.$router.push({
        path: "/health/consultation/index",
      });
    },
    async goQuery() {
      this.$router.push({
        path: "/health/query/index",
      });
    },
    async goActivation() {
      this.$router.push({
        path: "/health/activation/index",
      });
    },
    async goInsurance() {
      this.$router.push({
        path: "/health/insurance/index",
      });
    },
    async goApply() {
      this.$router.push({
        path: "/health/apply/index",
      });
    },
    async goBack() {
      this.$router.replace({
        path: "/classification",
      });
    },
  },
};
</script>

<style scoped lang="less">
.newTop {
  top: 280px !important;
}
.newpadding {
  padding: 36px 40px 0 !important;
}
.newmargin {
  margin-top: 30px !important;
}
.Index {
  position: relative;
  z-index: 1;
  width: 100%;
  height: 100%;
  background: linear-gradient(
    180deg,
    rgb(95, 141, 255) 6.107%,
    rgb(144, 181, 252) 39.695%,
    rgb(217, 240, 255) 99.237%
  );
  background-size: 100% 100%;
  border-radius: 0px;
  .window_bg {
    position: absolute;
    top: -50px;
    left: -50px;
    width: 630px;
    height: 684px;
    background: url(@/assets/colorBg/window_bg.png) no-repeat center;
    background-size: 100% 100%;
  }
}
.haerd {
  padding: 40px 30px;
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  .haerd_left {
    position: relative;
    z-index: 1;
    .backBtn {
      cursor: pointer;
      width: 251px;
      height: 90px;
      background: url(@/assets/colorBg/backBtn.png) no-repeat center;
      background-size: 100% 100%;
      font-family: Microsoft YaHei;
      font-weight: bold;
      font-size: 44px;
      color: #ffffff;
      display: flex;
      justify-content: center;
      align-items: center;
      text-shadow: 0px 1px 5px rgba(200, 121, 0, 0.5);
      border-radius: 96.5px;
      box-shadow: 0px 6px 12px 1px rgba(182, 118, 118, 0.27);
    }
    .title {
      margin-top: 40px;
      // margin-left: 20px;
      font-family: SourceHanSansSC-Regular-2;
      font-weight: bold;
      font-size: 70px;
      width: 45vw;
      color: #ffffff;
      line-height: 1.2;
    }
  }
  .haerd_right {
    position: absolute;
    right: 50px;
    top: 40px;
    z-index: 0;
    width: 294px;
    height: 245px;
    background: url("@/assets/health/healthIndex/healthIndex_subscript.png")
      no-repeat center;
    background-size: 100% 100%;
    //   opacity: 0.7;
  }
}

.module_box {
  // width: 100%;
  // margin: 0 40px 0;
  position: absolute;
  top: 340px;
  max-height: 910px;
  overflow-y: auto;
  padding-right: 10px;
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  margin: 0 35px;
  .health {
    position: relative;
    overflow: hidden;
    cursor: pointer;
    display: flex;
    // flex-direction: column;
    align-items: center;
    width: 325px;
    height: 150px;
    background: #ffffff;
    border-radius: 15px;
    margin-bottom: 20px;
    margin-right: 20px;
    .module_left {
      display: flex;
      // justify-content: center;
      margin-left: 20px;
      align-items: center;
      width: 170px;
      // height: 71px;
      font-family: SourceHanSansSC-Regular-2;
      font-weight: 500;
      font-size: 33px;
      letter-spacing: 2px;
      color: #333333;
      // margin-left: 20px;
      z-index: 99;
    }
    .w180 {
      width: 180px !important;
    }
    .module_right_icon1 {
      width: 250px;
      height: 253px;
      position: absolute;
      right: -25%;
      top: -50%;
      .module_right_icon2 {
        width: 130px;
        height: 117px;
        position: absolute;
        left: 22%;
        bottom: 4.5%;
        .module_right_icon3 {
          width: 70px;
          height: 70px;
          position: absolute;
          left: 13.5%;
          top: 23.5%;
        }
      }
    }
  }
  .health:nth-child(2n) {
    margin-right: 0;
  }
  .Register1 {
    background: url("@/assets/colorBg/green1.png") no-repeat center;
    background-size: 100% 100%;
  }
  .Register2 {
    background: url("@/assets/colorBg/green2.png") no-repeat center;
    background-size: 100% 100%;
  }
  .Register3 {
    background: url("@/assets/health/healthIndex/register.png") no-repeat center;
    background-size: 100% 100%;
  }
  .Pay1 {
    background: url("@/assets/colorBg/blue1.png") no-repeat center;
    background-size: 100% 100%;
  }
  .Pay2 {
    background: url("@/assets/colorBg/blue2.png") no-repeat center;
    background-size: 100% 100%;
  }
  .Pay3 {
    background: url("@/assets/health/healthIndex/pay.png") no-repeat center;
    background-size: 100% 100%;
  }
  .Medicine1 {
    background: url("@/assets/colorBg/pink1.png") no-repeat center;
    background-size: 100% 100%;
  }
  .Medicine2 {
    background: url("@/assets/colorBg/pink2.png") no-repeat center;
    background-size: 100% 100%;
  }
  .Medicine3 {
    background: url("@/assets/health/healthIndex/medicine.png") no-repeat center;
    background-size: 100% 100%;
  }
  .Consultation1 {
    background: url("@/assets/colorBg/green1.png") no-repeat center;
    background-size: 100% 100%;
  }
  .Consultation2 {
    background: url("@/assets/colorBg/green2.png") no-repeat center;
    background-size: 100% 100%;
  }
  .Consultation3 {
    background: url("@/assets/health/healthIndex/consultation.png") no-repeat
      center;
    background-size: 100% 100%;
  }
  .Query1 {
    background: url("@/assets/colorBg/purple1.png") no-repeat center;
    background-size: 100% 100%;
  }
  .Query2 {
    background: url("@/assets/colorBg/purple2.png") no-repeat center;
    background-size: 100% 100%;
  }
  .Query3 {
    background: url("@/assets/health/healthIndex/query.png") no-repeat center;
    background-size: 100% 100%;
  }
  .Activation1 {
    background: url("@/assets/colorBg/red1.png") no-repeat center;
    background-size: 100% 100%;
  }
  .Activation2 {
    background: url("@/assets/colorBg/red2.png") no-repeat center;
    background-size: 100% 100%;
  }
  .Activation3 {
    background: url("@/assets/health/healthIndex/activation.png") no-repeat
      center;
    background-size: 100% 100%;
  }
  .Insurance1 {
    background: url("@/assets/colorBg/orange1.png") no-repeat center;
    background-size: 100% 100%;
  }
  .Insurance2 {
    background: url("@/assets/colorBg/orange2.png") no-repeat center;
    background-size: 100% 100%;
  }
  .Insurance3 {
    background: url("@/assets/health/healthIndex/insurance.png") no-repeat
      center;
    background-size: 100% 100%;
  }
  .Apply1 {
    background: url("@/assets/colorBg/blue1.png") no-repeat center;
    background-size: 100% 100%;
  }
  .Apply2 {
    background: url("@/assets/colorBg/blue2.png") no-repeat center;
    background-size: 100% 100%;
  }
  .Apply3 {
    background: url("@/assets/health/healthIndex/apply.png") no-repeat center;
    background-size: 100% 100%;
  }
}

.prompt {
  width: 100%;
  position: absolute;
  bottom: 2vh;
  font-family: Microsoft YaHei;
  font-weight: 400;
  font-size: 30px;
  color: #666666;
  text-align: center;
}
// }
</style>
